/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { BotsCreators } from '../../../../store/actions/bots';
import gmtFormat from '../../../../util/gmtFormat';

import '../Analyze.scss';

import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';
import Carousel from '../../../../components/Carousel';
import BotCreateCustomReportButton from './Components/BotCreateCustomReportButton';
import { getBotCustomReports } from '../../../../store/actions/reports';

import iconWpp from '../../../../assets/images/icon-wpp.svg';
import iconTelegram from '../../../../assets/images/icon-telegram.svg';
import iconWebchat from '../../../../assets/images/icon-webchat.svg';
import iconMessenger from '../../../../assets/images/icon-messenger.svg';
import iconLido from '../../../../assets/images/icon_lido.svg';
import iconEnviado from '../../../../assets/images/icon_enviado.svg';
import iconEntregue from '../../../../assets/images/icon_entregue.svg';
import iconFalha from '../../../../assets/images/icon_delete.svg';
import iconView from '../../../../assets/images/icone_view.svg';
import iconHide from '../../../../assets/images/icone_esconder.svg';

const Historico = (props) => {
  const [selectedSession, setSelectedSession] = useState('');
  const [index, setIndex] = useState(0);

  const scrollRef = useRef();
  const messageRef = useRef();

  const {
    match,
    filterSessions,
    startDate,
    endDate,
    tags,
    channels,
    variables,
    sessions,
    messages,
    clearHistoryMessage,
    clearFilterSessions,
    historyMessage,
    timezone,
    bot,
    bots,
    user,
    botCustomReports,
  } = props;

  const { botid } = match.params;

  const [sessionsShowContact, setSessionsShowContact] = useState([]);
  const [sessionReportState, setSessionReportState] = useState('');

  // substituição do componentDidMount
  useEffect(() => {
    const { page, pages } = sessions;

    filterSessions({
      botid,
      start: startDate,
      end: endDate,
      count: 10,
      busc: false,
      page,
      pages,
      tags,
      channels,
      variables,
      timezone,
    });

    if (!Array.isArray(botCustomReports) || botCustomReports.length <= 0) {
      const { getBotCustomReports } = props;
      getBotCustomReports(botid, user?.dashboard_token);
    }
  }, []);

  useEffect(() => {
    const { page, pages } = sessions;

    if (page === pages || page === 0) {
      return;
    }

    filterSessions({
      botid,
      start: startDate,
      end: endDate,
      count: 10,
      page,
      pages,
      tags,
      channels,
      variables,
      timezone,
    });
  }, [index]);

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setIndex((indexInsideState) => indexInsideState + 1);
      }
    });

    intersectionObserver.observe(document.querySelector('#sentinel'));

    return () => intersectionObserver.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (botid && user && user.dashboard_token) {
        const { getBotCustomReports } = props;
        getBotCustomReports(botid, user.dashboard_token);
      }
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  // substituição do componentDidUpdate
  useEffect(() => {
    const { page, pages } = messages;

    if (selectedSession === '' || null || undefined) {
      return;
    }

    const body = {
      botid,
      sessionId: selectedSession,
      index: 0,
      count: 100,
      page,
      pages,
    };
    clearHistoryMessage();
    historyMessage(body);
  }, [selectedSession]);

  useEffect(() => {
    if (!bots) {
      const { listBotsRequest } = props;
      listBotsRequest();
    }
  }, [bots]);

  useEffect(() => {
    if (bot && sessions) {
      const { docs } = sessions;
      if (Array.isArray(docs)) {
        const { channelsSettings } = bot;
        const newSessionsShowContact = [];
        const showContact =
          channelsSettings && channelsSettings.exposeContactNumber;
        docs.forEach((session) =>
          newSessionsShowContact.push({
            id: session._id,
            contactNumber: session.contact,
            channel: session.channel,
            showContact,
          })
        );
        setSessionsShowContact(newSessionsShowContact);
      }
    }
  }, [sessions]);

  useEffect(() => {
    if (selectedSession && selectedSession !== '') {
      const hasReport = botCustomReports.find(
        ({ sessionId }) => sessionId && sessionId === selectedSession
      );

      if (hasReport) {
        setSessionReportState(hasReport.status);
      } else {
        setSessionReportState('');
      }
    }
  }, [botCustomReports, selectedSession]);

  // substituição do componentWillUnmount
  useEffect(() => {
    return () => {
      clearFilterSessions();
      clearHistoryMessage();
    };
  }, []);

  // "componentDidUpdate" Modificando a session do array de dependencias para fazer o reload
  const receiveSession = (sessionId) => {
    if (sessionId === null || undefined) {
      toastr.error('Ops', 'Por favor informe uma sessão');
      return;
    }

    if (sessionId === selectedSession) {
      return;
    }

    clearHistoryMessage();
    setSelectedSession(sessionId);
  };

  const onClickFilter = async () => {
    setSelectedSession('');

    const { startDate, endDate, filterSessions } = props;

    await clearHistoryMessage();

    await filterSessions({
      botid,
      start: startDate,
      end: endDate,
      count: 10,
      busc: true,
      page: 0,
      pages: 1,
      tags,
      channels,
      variables,
      timezone,
    });
  };

  const onScrollMessage = async () => {
    const { page, pages } = messages;

    if (page === pages || page === 0) {
      return;
    }

    const scrollTopMessage = messageRef.current.scrollTop;
    if (
      scrollTopMessage ===
      messageRef.current.scrollHeight - messageRef.current.offsetHeight
    ) {
      const body = {
        botid,
        sessionId: selectedSession,
        count: 100,
        page,
        pages,
      };
      await historyMessage(body);
    }
  };

  const treatMessage = (message) => {
    if (message === '**********') return '✱✱✱✱✱';
    const linkRegex =
      /((http:\/\/|https:\/\/|ftp:\/\/)|(www.))+([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/gi;
    const strongRegex = /\*(.*?)\*/g;
    const breaklineRegex = /\n/g;
    let messageTreated;

    if (!message) {
      message = '';
    }

    messageTreated = message.replace(linkRegex, function (str) {
      if (!str.match(/http/)) {
        return `<a target="_blank" href="http://${str}">${str}</a>`;
      }
      return `<a target="_blank" href="${str}">${str}</a>`;
    });

    messageTreated = messageTreated.replace(strongRegex, function (str) {
      return `<strong>${str.substr(1, str.length - 2)}</strong>`;
    });

    messageTreated = messageTreated.replace(breaklineRegex, '<br/>');

    return messageTreated;
  };

  const imageChannel = (name) => {
    if (name === 'whatsapp') {
      return <img src={iconWpp} style={{ width: 36 }} alt="WhatsApp" />;
    }
    if (name === 'webchat') {
      return <img src={iconWebchat} alt="Webchat" />;
    }
    if (name === 'FacebookMessenger' || name === 'messenger') {
      return <img src={iconMessenger} alt="Messenger" />;
    }
    if (name === 'telegram') {
      return <img src={iconTelegram} alt="Telegram" />;
    }
    return <span />;
  };

  const buildBotTransferUrl = (botTransfer) => {
    if (!bots && !Array.isArray(bots)) {
      return false;
    }

    const { transferTo } = botTransfer;
    const transferredBot = bots.find(({ _id }) => _id === transferTo);
    const url = `${window.location.origin}/bots/${transferTo}/analise`;
    const link = transferredBot ? transferredBot.title : transferTo;

    return (
      <>
        Transferido para o bot <a href={url}>{link}</a>
      </>
    );
  };

  const formatContactNumber = (contactNumber) => {
    const unavailableData = 'Dado indisponível';
    if (!contactNumber) {
      return unavailableData;
    }
    const isSessionId = new RegExp(
      '^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$'
    );

    if (isSessionId.test(contactNumber)) {
      return unavailableData;
    }

    return `+${contactNumber[0]}${contactNumber[1]} (${contactNumber[2]}${
      contactNumber[3]
    }) ${contactNumber.substring(4)}`;
  };

  const onClickChangeSensitiveInfo = (element) => {
    const { showContact } = element;
    const newSessionsShowContact = [...sessionsShowContact];
    const index = sessionsShowContact.indexOf(element);
    newSessionsShowContact[index].showContact = !showContact;
    setSessionsShowContact(newSessionsShowContact);
  };

  const renderHistoryIdentification = (session) => {
    const { _id: sessionId, channel } = session;

    if (channel !== 'whatsapp') {
      return <span className="code-item">{sessionId}</span>;
    }

    const { channelsSettings } = bot;
    const element = sessionsShowContact.find(({ id }) => id === sessionId);
    if (!element) {
      return false;
    }

    const { id, contactNumber, showContact } = element;
    const text = showContact ? formatContactNumber(contactNumber) : id;
    const icon = showContact ? iconHide : iconView;
    const hasToHide =
      (user?.selectedCompany?.claim?.name === 'Admin' &&
        channelsSettings?.exposeContactNumber) ||
      (user?.selectedCompany?.claim?.name === 'Root' &&
        channelsSettings?.exposeContactNumber);

    return (
      <div className="history-contact-info">
        {hasToHide ? (
          <img
            className="icon-view-info"
            src={icon}
            alt="View"
            onClick={() => onClickChangeSensitiveInfo(element)}
          />
        ) : (
          false
        )}
        <span className="sensitive-info-span">{text}</span>
      </div>
    );
  };

  const renderCreateCustomReportButton = () => {
    if (!bot) return false;
    if (!selectedSession || selectedSession === '') return false;

    switch (sessionReportState) {
      case 'ok': {
        const reportsSessions = botCustomReports.find(
          ({ sessionId }) => sessionId && sessionId === selectedSession
        );
        return (
          <a
            href={reportsSessions?.url || ''}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary custom-report-button-generate-container"
            download
          >
            Download
          </a>
        );
      }
      case 'pending':
        return (
          <div className="semaforo pendente custom-report-pending-report" />
        );
      case 'error':
        return (
          <>
            <div className="semaforo erro custom-report-error-report" />
            {/* <BotCreateCustomReportButton sessionId={selectedSession} /> */}
          </>
        );
      default:
        return <BotCreateCustomReportButton sessionId={selectedSession} />;
    }
  };

  return (
    <div>
      <FilterData onClickFilter={onClickFilter} showMoreFilters />
      <div className="container-info-historico">
        <div className="analise-menu-historico" ref={scrollRef}>
          {sessions.docs.map((s, index) => (
            <div
              key={(s.id, index)}
              className={
                selectedSession === s._id
                  ? 'item-historico back-item'
                  : 'item-historico board-item'
              }
              onClick={() => receiveSession(s._id)}
            >
              <span className="number-item">{imageChannel(s.channel)}</span>
              <div className="item-date-code">
                <span className="date-item">
                  <b>
                    {moment(s.when)
                      .utcOffset(gmtFormat(timezone))
                      .format('DD/MM/YYYY HH:mm')}
                  </b>
                </span>
                {renderHistoryIdentification(s)}
              </div>
            </div>
          ))}
          <div id="sentinel" />
        </div>
        <div className="intecessor" />
        <div className="container-analise-menu-conversa">
          {renderCreateCustomReportButton()}
          <div
            className="analise-menu-conversa"
            ref={messageRef}
            onScroll={onScrollMessage}
          >
            {sessions.docs.length === 0 || undefined || null ? (
              <div className="no-session-warn">
                <strong>Nenhuma sessão encontrada</strong>
                <small>Utilize os filtros acima para listar suas sessões</small>
              </div>
            ) : (
              !selectedSession && (
                <span style={{ textAlign: 'center' }}>
                  Selecione uma sessão para ver as conversas
                </span>
              )
            )}

            {selectedSession && messages.docs && !messages.docs.length && (
              <div>
                <span style={{ textAlign: 'center' }}>
                  Essa sessão não tem nenhuma conversa
                </span>
              </div>
            )}

            {messages.docs.map((s, index) => {
              if (s.media === 'Menu') {
                return (
                  <div key={`historico-Text${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <div
                              className="area-bot"
                              dangerouslySetInnerHTML={{
                                __html: treatMessage(s.text),
                              }}
                            />
                            {s.status !== 'none' ? (
                              <img
                                alt="Message bot status"
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <div
                            className="area-user"
                            dangerouslySetInnerHTML={{
                              __html: treatMessage(s.text),
                            }}
                          />
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Localization') {
                return (
                  <div key={`historico-Text${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <div
                              className="area-bot"
                              dangerouslySetInnerHTML={{
                                __html: treatMessage(s.text),
                              }}
                            />
                            {s.status !== 'none' ? (
                              <img
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <div className="area-user">
                            <iframe
                              width="500"
                              height="350"
                              id="gmap_canvas"
                              src={`${s.text}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                              frameBorder="0"
                              scrolling="no"
                              marginHeight="0"
                              marginWidth="0"
                            />
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Text') {
                return (
                  <div key={`historico-Text${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <div
                              className="area-bot"
                              dangerouslySetInnerHTML={{
                                __html: treatMessage(s.text),
                              }}
                            />
                            {s.status !== 'none' ? (
                              <img
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <div
                            className="area-user"
                            dangerouslySetInnerHTML={{
                              __html: treatMessage(s.text),
                            }}
                          />
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Image') {
                return (
                  <div key={`historico-Image${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <img
                              className="area-bot"
                              src={s.text}
                              alt="area-bot"
                            />
                            {s.status !== 'none' ? (
                              <img
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <img
                            className="area-user"
                            src={s.text}
                            alt="area-user"
                          />
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Video') {
                return (
                  <div key={`historico-Video${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <div className="area-bot">
                              <video
                                preload="auto"
                                controls
                                className="img-fluid container-document-webchat"
                              >
                                <source src={s.text} type="video/mp4" />
                              </video>
                            </div>
                            {s.status !== 'none' ? (
                              <img
                                alt="Message bot status"
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <div className="area-user">
                            <video
                              preload="auto"
                              controls
                              className="img-fluid container-document-webchat"
                            >
                              <source src={s.text} type="video/mp4" />
                            </video>
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Audio') {
                return (
                  <div key={`historico-Audio${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <div
                              className="area-bot"
                              style={{ width: 'auto', padding: 0 }}
                            >
                              <audio
                                preload="auto"
                                controls
                                className="preview-audio container-document-webchat"
                              >
                                <source src={s.text} type="audio/mp3" />
                              </audio>
                            </div>
                            {s.status !== 'none' ? (
                              <img
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <div
                            className="area-bot"
                            style={{ width: 'auto', padding: 0 }}
                          >
                            <audio
                              preload="auto"
                              controls
                              className="preview-audio container-document-webchat"
                            >
                              <source src={s.text} type="audio/mp3" />
                            </audio>
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'Document') {
                return (
                  <div key={`historico-Documento${index}`}>
                    <div>
                      {s.sent === false ? (
                        <div className="container-area-bot">
                          <div className="container-bot-message">
                            <a
                              className="area-bot"
                              href={s.text}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="/assets/images/icons/document-preview.svg"
                                className="img-fluid"
                                alt=""
                              />
                              <span className="historico-document-name">
                                {s?.title ? s.title : 'Documento'}
                              </span>
                            </a>
                            {s.status !== 'none' ? (
                              <img
                                alt="Message bot status"
                                className="message-bot-status"
                                src={
                                  s.status === 'read'
                                    ? iconLido
                                    : s.status === 'delivered'
                                    ? iconEntregue
                                    : s.status === 'sent'
                                    ? iconEnviado
                                    : iconFalha
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                      {s.sent === true ? (
                        <div className="container-area-user">
                          <a
                            className="area-user"
                            href={s.text}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/assets/images/icons/document-preview.svg"
                              className="img-fluid"
                              alt=""
                            />
                            <span className="historico-document-name">
                              {s?.title ? s.title : 'Documento'}
                            </span>
                          </a>
                          <span className="horario-message">
                            {moment(s.when)
                              .utcOffset(gmtFormat(timezone))
                              .format('HH:mm')}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (s.media === 'CAROUSEL') {
                return (
                  <div key={`historico-${index}`}>
                    <div className="container-bot-message">
                      <div
                        style={{
                          width: '210px',
                          position: 'relative',
                          marginBottom: '24px',
                        }}
                      >
                        <Carousel carouselData={s.carouselMessage} />
                      </div>
                      {s.status !== 'none' ? (
                        <img
                          className="message-bot-status mb-5"
                          src={
                            s.status === 'read'
                              ? iconLido
                              : s.status === 'delivered'
                              ? iconEntregue
                              : s.status === 'sent'
                              ? iconEnviado
                              : iconFalha
                          }
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              if (
                !s.media &&
                s.clientAction &&
                s.clientAction.type === 'CAROUSEL'
              ) {
                return (
                  <div key={`historico-${index}`}>
                    <div className="container-area-user">
                      <div className="area-user area-user--orange">
                        Clique no botão{' '}
                        <strong>
                          {s.clientAction.data.clickedButton.label}
                        </strong>{' '}
                        do card:{' '}
                        <strong>{s.clientAction.data.clickedCard.title}</strong>
                      </div>

                      <span className="horario-message">
                        {moment(s.when)
                          .utcOffset(gmtFormat(timezone))
                          .format('HH:mm')}
                      </span>
                    </div>
                  </div>
                );
              }

              if (s.media && s.media === 'BotTransfer') {
                return (
                  <div key={`historico-bot-transfer-${index}`}>
                    <div className="bot-transfer-center-text">
                      <span className="horario-message">
                        {moment(s.when)
                          .utcOffset(gmtFormat(timezone))
                          .format('HH:mm')}
                      </span>
                    </div>
                    <div className="bot-transfer-divider" />
                    <div className="bot-transfer-ballon">
                      <div className="area-user area-user--orange">
                        <span className="bot-transfer-center-text">
                          {buildBotTransferUrl(s.botTransfer)}
                        </span>
                        <span className="bot-transfer-center-text">{`Sessão: ${s?.botTransfer?.newSessionId}`}</span>
                      </div>
                    </div>
                  </div>
                );
              }
              if (s.media && s.media === 'quickAccess') {
                return (
                  <div key={`historico-${index}`}>
                    <div className="container-area-user">
                      <div className="area-user area-user--blue">
                        Acesso rápido para <strong>{s.quickAccess}</strong>
                      </div>

                      <span className="horario-message">
                        {moment(s.when)
                          .utcOffset(gmtFormat(timezone))
                          .format('HH:mm')}
                      </span>
                    </div>
                  </div>
                );
              }
              if (s.media && s.media === 'EMAIL') {
                return (
                  <div key={`historico-${index}`}>
                    <div className="container-area-bot">
                      <div className="area-bot area-user--orange">
                        Envio de <strong>E-mail</strong> - Assunto:{' '}
                        <strong>{s.emailSubject}</strong>
                      </div>

                      <span className="horario-message">
                        {moment(s.when)
                          .utcOffset(gmtFormat(timezone))
                          .format('HH:mm')}
                      </span>
                    </div>
                  </div>
                );
              }
              if (s.media && s.media === 'SMS') {
                return (
                  <div key={`historico-${index}`}>
                    <div className="container-area-bot">
                      <div className="area-bot area-user--orange">
                        Envio de <strong>SMS</strong> - Mensagem:{' '}
                        <strong>{s.text || ''}</strong>
                      </div>

                      <span className="horario-message">
                        {moment(s.when)
                          .utcOffset(gmtFormat(timezone))
                          .format('HH:mm')}
                      </span>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  bots: state.bots.list,
  sessions: state.bots.sessions,
  messages: state.bots.messages,
  sessionsFilter: state.bots.sessionsFilter,
  startDate: state.filter.startDate,
  endDate: state.filter.endDate,
  tags: state.filter.nameTags,
  channels: state.filter.channels,
  variables: state.filter.variables,
  timezone: state.bots.bot.settings.timezone.fuso,
  user: state.users.signedUser,
  botCustomReports: state.reports.botCustomReports,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, getBotCustomReports }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Historico))
);
